import React, { useMemo, useState, useEffect, memo } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { IconButton, Tooltip } from '@material-ui/core';
import { DataGrid, esES } from '@mui/x-data-grid';
import { Dialpad } from '@material-ui/icons';
// WService
import { wsFindBy } from 'services/WService';
import moment from 'moment';

const columns = [
  {
    field: 'num',
    width: 10,
    align: 'right',
    headerName: '#',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'zone_code',
    width: 70,
    headerName: 'Zona',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocSubDescription',
    width: 100,
    headerName: 'T.Doc Sun.',
    hideable: false,
    sortable: false,
  },
  { field: 'U_SYP_MDSD', width: 100, headerName: 'Serie Doc.', hideable: false, sortable: false },
  { field: 'U_SYP_MDCD', width: 100, headerName: 'Corr. Sun.', hideable: false, sortable: false },
  { field: 'DocNum', width: 100, headerName: 'Num. SAP', hideable: false, sortable: false },
  {
    field: 'DocStatus',
    width: 100,
    headerName: 'Esta Doc.',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'ImportEnt',
    width: 75,
    headerName: 'HR',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'sheet_distribution_state',
    width: 100,
    headerName: 'Estado HR',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  { field: 'TaxDate', width: 100, headerName: 'Fec. Doc.', hideable: false, sortable: false },
  { field: 'DocDueDate', width: 100, headerName: 'Fec. Vto.', hideable: false, sortable: false },
  { field: 'backDay', width: 100, headerName: 'Dias atrás', hideable: false, sortable: false },
  {
    field: 'DiscPrcnt',
    width: 70,
    align: 'right',
    headerName: '%Dsct.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocTotal',
    width: 100,
    align: 'right',
    headerName: 'Total Doc.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'wtliable_retention',
    width: 100,
    align: 'right',
    headerName: 'Retención',
    sortable: false,
    type: 'number',
    disableColumnMenu: true,
  },
  {
    field: 'PaidToDate',
    width: 100,
    align: 'right',
    headerName: 'Pagado',
    hideable: false,
    sortable: false,
  },
  {
    field: 'Saldo',
    width: 100,
    align: 'right',
    headerName: 'Saldo',
    hideable: false,
    sortable: false,
  },
  {
    field: 'creditNotes',
    width: 100,
    align: 'right',
    headerName: 'Mto. NC',
    sortable: false,
    type: 'number',
    disableColumnMenu: true,
  },

  {
    field: 'totalPaid',
    width: 150,
    align: 'right',
    type: 'number',
    editable: true,
    headerName: 'Pago T.',
    valueSetter: (params) => {
      params.row.totalPaid = parseFloat(params.value).toFixed(2);
      return params.row;
    },
  },
];

function PaymentDocumentsAcomplished(props) {
  const { setDocuments } = props;

  const { setTotalAmount, zoneId } = props;
  const { businessPartner, showNotify } = props;

  const [loading, setLoading] = useState(false);

  const [aviableDocuments, setAviableDocuments] = useState([]);
  const [totalPay, setTotalPay] = useState(0);
  const [handlePay, setHandlePay] = useState(0);
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectionIds, setSelectionIds] = useState([]);

  const dataGridColumns = useMemo(() => {
    let newColumns = [...columns];
    let totalPaidIndex = newColumns.findIndex((column) => column.field === 'totalPaid');
    newColumns[totalPaidIndex].renderCell = renderTotalPaidCell;
    return newColumns;
  }, []);

  const aviableDocumentsMapped = useMemo(() => {
    const selectedFacturas = selectionIds.filter(id => id.startsWith('18-'));
    const selectedNCs = selectionModel.filter(doc => parseInt(doc.ObjType) === 19);
    const totalNCSelected = selectedNCs.reduce((sum, nc) => sum + parseFloat(nc.DocTotal || 0), 0);

    return aviableDocuments.map((item, i) => {

      let hrState = '';
      switch (item.sheet_distribution_state) {
        case 'W': hrState = 'Reparto(W)'; break;
        case '1': hrState = 'Liq Mercadería(1)'; break;
        case '2': hrState = 'Liq Mercadería+(2)'; break;
        case '3': hrState = 'Liq Documento(3)'; break;
        case '4': hrState = 'Liq Documento+(4)'; break;
        case 'L': hrState = 'Liq HR(L)'; break;
        case '5': hrState = 'Cerrado(5)'; break;
      }
      let mtoNC = 0;
      if (
        parseInt(item.ObjType) === 18 &&
        selectedFacturas.length === 1 &&
        `18-${item.DocEntry}` === selectedFacturas[0]
      ) {
        mtoNC = totalNCSelected;
      }

      return {
        id: generateId(item),
        zone_code: item.zone_code,
        DocEntry: item.DocEntry,
        ObjType: item.ObjType,
        num: i + 1,
        DocSubDescription: item.DocSubDescription,
        U_SYP_MDSD: item.U_SYP_MDSD || item.U_SYP_MDSO,
        U_SYP_MDCD: item.U_SYP_MDCD || item.U_SYP_MDCO,
        U_SYP_MDCO: item.U_SYP_MDCO,
        DocNum: item.DocNum,
        DocStatus: item.DocStatus === 'O' ? 'Abierto' : 'Cerrado',
        ImportEnt: item.ImportEnt,
        sheet_distribution_state: hrState,
        TaxDate: moment(item.TaxDate).format('DD/MM/YYYY'),
        DocDueDate: moment(item.DocDueDate).format('DD/MM/YYYY'),
        backDay: moment().diff(moment(item.DocDueDate), 'days') + ' días',
        DiscPrcnt: item.DiscPrcnt,
        DocTotal: item.DocTotal,
        PaidToDate: item.PaidToDate,
        Saldo: item.Saldo,
        creditNotes: mtoNC,
        wtliable_retention: parseFloat(item.wtliable_retention || 0).toFixed(2),
        totalPaid: parseFloat(item.totalPaid || 0).toFixed(2),
      };
    });
  }, [aviableDocuments, selectionModel, selectionIds]);

  function renderTotalPaidCell(cellValue) {
    let tooltipMsg = '';
    if (handlePay > 0) {
      if (handlePay > totalPay) {
        tooltipMsg = 'Agrega Doc.';
      } else if (handlePay == totalPay) {
        tooltipMsg = 'Completo';
      } else if (cellValue.value < totalPay - handlePay) {
        tooltipMsg = 'Desmarcar';
      } else {
        tooltipMsg = `= ${(cellValue.value - (totalPay - handlePay)).toFixed(2)}`;
      }
    }
    return (
      <div>
        {selectionModel.some((x) => x.DocEntry === cellValue.id) ? (
          <Tooltip title={tooltipMsg}>
            <IconButton aria-label="delete">
              <Dialpad fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : undefined}
        {cellValue.value}
      </div>
    );
  }

  async function getDocuments(CardCode, CardType) {
    let response, creditNotesResponse;
    let queryParams = { CardCode };
    if (zoneId !== undefined) {
      queryParams.base_zone_id = zoneId;
    }
    setAviableDocuments([]);
    setLoading(true);
    if (CardType === 'C') {
      [response, creditNotesResponse] = await Promise.all([
        wsFindBy('sap/business-partner/receivable', queryParams),
        wsFindBy('sap/business-partner/credit-note', { CardCode, pendient: 1 }),
      ]);
    } else {
      [response, creditNotesResponse] = await Promise.all([
        wsFindBy('sap/provider/receivable', queryParams),
        wsFindBy('sap/provider/credit-note', { CardCode, pendient: 1 }),
      ]);
    }

    let creditNotes = [];
    if (creditNotesResponse !== undefined) {
      if (creditNotesResponse.success) {
        if (Array.isArray(creditNotesResponse.data)) {
          creditNotes = creditNotesResponse.data;
        }
      }
    }

    if (response.success === false) {
      showNotify('Error al recuperar los documentos del socio negocio', 'error');
      setLoading(false);
      return;
    }
    let newData = response.data.map((item) => {
      let mObject = {
        ...item,
        totalPaid: item.Saldo,
        creditNotes: [],
        totalCN: 0,
      };
      let filterCN = creditNotes.filter((cn) => {
        return (
          cn.U_SYP_MDSO === item.U_SYP_MDSD && // Serie
          cn.U_SYP_MDCO === item.U_SYP_MDCD && // Correlativo
          cn.U_SYP_MDTO === item.U_SYP_MDTD
        ); // Tipo documento
      });

      if (filterCN.length > 0) {
        mObject.creditNotes = filterCN;
        mObject.totalCN = filterCN.reduce(
          (reducer, cn) => reducer + (parseFloat(cn.DocTotal) - parseFloat(cn.PaidToDate)),
          0,
        );
        // mObject.totalPaid -= mObject.totalCN; Se evita restar el total de las notas de crédito al total pagado, ya que se maneja por separado
      }

      return mObject;
    });
    if (creditNotes.length > 0) {
      for (let i = newData.length - 1; i >= 0; i--) {
        let documento = newData[i];
        if (documento.creditNotes.length > 0) {
          newData.splice(i + 1, 0, ...documento.creditNotes);
        }
      }
    }

    setAviableDocuments(newData);
    setLoading(false);
  }

  function generateId(document) {
    return `${document.ObjType}-${document.DocEntry}${
      document.ObjType == 14 ? `-${document.U_SYP_MDSO}|${document.U_SYP_MDCO}` : ''
    }`;
  }

  function calculation(selectedRowData) {
    let total = selectedRowData
      .filter((item) => !isNaN(item.totalPaid))
      .reduce((sum, item) => sum + parseFloat(parseFloat(item.totalPaid).toFixed(2)), 0);
    total = parseFloat(total.toFixed(6));
    if (total < 0) {
      total = 0;
    }
    setTotalPay(total); //setea suma de los valores seleccionados
  }

  // function mergeData(ids) {
  //   let difference = ids.length - selectionIds.length;
  //   let addeds = [];
  //   let deleteds = [];
  //   if (difference > 0) {
  //     if (difference === 1) {
  //       addeds[0] = ids.find((item) => !selectionIds.includes(item));
  //     } else {
  //       addeds = ids.filter((item) => !selectionIds.includes(item));
  //     }
  //   } else {
  //     if (difference === -1) {
  //       deleteds[0] = selectionIds.find((item) => !ids.includes(item));
  //     } else {
  //       deleteds = selectionIds.filter((item) => !ids.includes(item));
  //     }
  //   }

  //   if (addeds.length > 0) {
  //     for (let documentId of addeds) {
  //       let data = documentId.split('-');
  //       if (data[0] === '13' || data[0] === '18') {
  //         let document = aviableDocuments.find((item) => item.DocEntry === data[1]);
  //         if (document.creditNotes?.length > 0) {
  //           ids = ids.concat(document.creditNotes.map((item) => generateId(item)));
  //         }
  //       }
  //     }
  //   }

  //   if (deleteds.length > 0) {
  //     for (let documentId of deleteds) {
  //       let data = documentId.split('-');
  //       if (data[0] === '13' || data[0] === '18') {
  //         let document = aviableDocuments.find((item) => item.DocEntry === data[1]);
  //         if (document.creditNotes?.length > 0) {
  //           for (let cnId of document.creditNotes.map((item) => generateId(item))) {
  //             let index = ids.indexOf(cnId);
  //             if (index !== -1) {
  //               ids.splice(index, 1);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }

  //   setSelectionIds(ids);
  // }
  function mergeData(ids) {
    const removedFacturas = selectionIds
      .filter((prevId) => !ids.includes(prevId))
      .map((id) => {
        const [objType, docEntry] = id.split('-');
        return { objType, docEntry };
      })
      .filter(({ objType }) => objType === '18');
    let newIds = [...ids];
    removedFacturas.forEach(({ docEntry }) => {
      aviableDocuments.forEach((doc) => {
        if (
          doc.ObjType === '19' &&
          String(doc.U_SYP_MDCO) === String(
            aviableDocuments.find(
              (f) => f.ObjType === '18' && String(f.DocEntry) === String(docEntry)
            )?.U_SYP_MDCD
          )
        ) {
          const ncId = `19-${doc.DocEntry}`;
          newIds = newIds.filter((id) => id !== ncId);
        }
      });
    });
    setSelectionIds(newIds);
  }

  function editCell(e) {
    let objIndex = aviableDocuments.findIndex((obj) => `${obj.ObjType}-${obj.DocEntry}` == e.id);
    let value = e.value;
    setAviableDocuments((docs) => {
      const newDocs = [...docs];
      newDocs[objIndex] = { ...newDocs[objIndex], totalPaid: parseFloat(value) };
      return newDocs;
    });
  }

  useEffect(() => {
    if (businessPartner === undefined) return;
    getDocuments(businessPartner.CardCode, businessPartner.CardType);
  }, [businessPartner, zoneId]);

  useEffect(() => {
    setTotalAmount(totalPay);
    setDocuments(
      selectionModel
        .filter(doc => parseInt(doc.ObjType) === 18)
        .map(document => {
          // Buscar el valor actualizado de totalPaid en aviableDocuments
          const docActual = aviableDocuments.find(
            d => d.ObjType === document.ObjType && String(d.DocEntry) === String(document.DocEntry)
          );
          let sum = docActual ? parseFloat(docActual.totalPaid) : 0;
          let data = {
            DocEntry: document.DocEntry,
            ObjType: document.ObjType,
            Sum: sum < 0 ? 0 : sum,
            TaxDate: document.TaxDate,
          };
          // Si tiene NC seleccionadas, agrégalas
          const selectedNCs = selectionModel.filter(doc => parseInt(doc.ObjType) === 19);
          if (selectedNCs.length > 0) {
            data.CreditNotes = selectedNCs.map(nc => nc.DocEntry);
          }
          return data;
        })
    );
  }, [totalPay, selectionModel, setDocuments, setTotalAmount, aviableDocuments]);

  useEffect(() => {
    setAviableDocuments((docs) => {
      const updatedDocs = docs.map((doc) => ({ ...doc }));
      const selectedFacturas = selectionIds.filter(id => id.startsWith('18-'));
      const selectedNCs = selectionModel.filter((row) => row.ObjType === '19');
      const totalNC = selectedNCs.reduce(
        (sum, nc) => sum + parseFloat(nc.DocTotal || 0),
        0
      );
      if (selectedFacturas.length === 1) {
        const facturaId = selectedFacturas[0].split('-')[1];
        updatedDocs.forEach((doc) => {
          if (doc.ObjType === '18' && String(doc.DocEntry) === String(facturaId)) {
            doc.creditNotes = totalNC;
            doc.totalPaid = ((parseFloat(doc.Saldo) - totalNC) - doc.wtliable_retention).toFixed(2);
          } else if (doc.ObjType === '18') {
            doc.creditNotes = 0;
            doc.totalPaid = parseFloat(doc.Saldo).toFixed(2);
          }
        });
      } else {
        updatedDocs.forEach((doc) => {
          if (doc.ObjType === '18') {
            doc.creditNotes = 0;
            doc.totalPaid = parseFloat(doc.Saldo).toFixed(2);
          }
        });
      }
      return updatedDocs;
    });
  }, [selectionModel, selectionIds]);

  useEffect(() => {
    const selectedIDs = new Set(selectionIds);
    const selectedRowData = aviableDocuments.filter((row) =>
      selectedIDs.has(`${row.ObjType}-${row.DocEntry}`)
    );
    const total = selectedRowData
      .filter((item) => !isNaN(item.totalPaid))
      .reduce((sum, item) => sum + parseFloat(item.totalPaid), 0);

    setTotalPay(parseFloat(total.toFixed(6)));
    setTotalAmount(parseFloat(total.toFixed(6)));
  }, [selectionIds, aviableDocuments]);

  return (
    <CardContainer icon={null} title="Documentos pendientes de pagos Efectuados:" style={{ height: '600px' }}>
      <DataGrid
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        checkboxSelection
        rowHeight={35}
        columns={dataGridColumns}
        selectionModel={selectionIds}
        onSelectionModelChange={(model) => {
          let selectedIDs = new Set(model);
          const selectedFacturas = Array.from(selectedIDs).filter(id => id.startsWith('18-'));
          const selectedNCs = Array.from(selectedIDs).filter(id => id.startsWith('19-'));
          if (selectionIds.some(id => id.startsWith('18-')) && !selectedIDs.has(selectionIds.find(id => id.startsWith('18-')))) {
            selectedIDs = new Set(Array.from(selectedIDs).filter(id => !id.startsWith('19-')));
          }
          if (selectedFacturas.length > 1) {
            selectedIDs = new Set(Array.from(selectedIDs).filter(id => !id.startsWith('19-')));
          }
          if (selectedNCs.length > 0 && selectedFacturas.length > 1) {
            const facturaSeleccionada = selectionIds.find(id => id.startsWith('18-'));
            selectedIDs = new Set([
              ...Array.from(selectedIDs).filter(id => !id.startsWith('18-')),
              facturaSeleccionada,
            ]);
          }
          const selectedRowData = aviableDocuments.filter((row) =>
            selectedIDs.has(`${row.ObjType}-${row.DocEntry}`)
          );
          setSelectionModel(selectedRowData);
          calculation(selectedRowData);
          mergeData(Array.from(selectedIDs));
        }}
        loading={loading}
        disableSelectionOnClick
        // isRowSelectable={({ row }) => ![14/*,19*/].includes(parseInt(row.ObjType))}
        isRowSelectable={({ row }) => {
          const selectedFacturas = selectionIds.filter(id => id.startsWith('18-'));
          const selectedNCs = selectionModel.filter(doc => parseInt(doc.ObjType) === 19);
          if (selectedFacturas.length > 1) {
            if (parseInt(row.ObjType) === 19) return false;
          }
          if (selectedNCs.length > 0) {
            if (parseInt(row.ObjType) === 18) {
              if (selectedFacturas.length === 1 && selectionIds.includes(`18-${row.DocEntry}`)) return true;
              return false;
            }
          }
          if (parseInt(row.ObjType) === 19) {
            if (selectedFacturas.length !== 1) return false;
            const factura = aviableDocuments.find(doc => `18-${doc.DocEntry}` === selectedFacturas[0]);
            if (!factura) return false;
            let totalPaidFactura = parseFloat(factura.totalPaid);
            if (selectionIds.includes(`19-${row.DocEntry}`)) {
              totalPaidFactura += parseFloat(row.DocTotal || 0);
            }
            if (parseFloat(row.DocTotal) > totalPaidFactura) return false;
            return true;
          }
          return true;
        }}
        rows={aviableDocumentsMapped}
        onCellEditCommit={(e) => {
          editCell(e);
          calculation(selectionModel);
        }}
      />
    </CardContainer>
  );
}

export default memo(PaymentDocumentsAcomplished);
